"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * @bit
 * @name today
 * @description Returns the date of today
 * @returns {date}: today's date
 *
 */
var today = function today() {
  return new Date();
};

exports.default = today;

//# sourceMappingURL=impl.js.map


// WEBPACK FOOTER //
// ./src/components/utils/today/belle.react-components/1/dist/impl.js